import React, { useContext, useEffect, useRef, useState } from 'react'
import Card from '../../../../Base/Components/Card/Card'
import Loader from '../../../../Base/Components/Loader/Loader';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { changePermisoPurchaseRequestDetailBodega, getListaRequisasAutorizarBodega } from '../../../../API/Compras/Requisas/PurchareDetailsRequests';
import DialogPassword from '../../../../Base/Components/Dialog/DialogPassword/DialogPassword';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { toastShow } from '../../../../Base/Services/ToastService';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import RequisaComprasModalCrud from '../CrudRequisa/RequisaComprasModalCrud';
import { Button } from 'primereact/button';

const LiberarBodegaScreen = () => {

    const toast = useRef(null);

    const { userAuth } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [password, setPassword] = useState('');
    const [showDialogPassword, setShowDialogPassword] = useState(false);
    const [showModal, setModal] = useState(false);
    const [requisaEdit, setRequisaEdit] = useState(null);




    const getInfo = async () => {
        setLoading(true);
        const t = await getListaRequisasAutorizarBodega();
        setData(t);
        setLoading(false);
    }


    const colums = [
        {
            header: 'Fecha',
            field: 'DateCreated',
            Format: 'DateTime',
        },
        {
            header: 'Estado',
            field: 'EstadoPD',
            Format: 'Estado',
            body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.EstadoPD }),
            className: 'medium',

        },
        {
            // NUMERO ORDEN
            field: 'PurchaseRequest',
            header: 'No. Requisa',
            className: "small",
            body: (rowData) => (rowData.PurchaseRequest),
            frozen: "frozen",
            alignFrozen: "left",
            Sumary: 'count',
            align: 'center',
            Format: 'Modal'
        },
        {
            header: 'Codigo Producto',
            field: 'CodigoProducto',
            className: 'small',
            frozen: 'true',

        },
        {
            header: 'Producto',
            field: 'NombreProducto',
            className: 'XXlarge',
            Sumary: 'count',
            frozen: 'true',

        },
        {
            header: 'Descripción',
            field: 'Description',
            className: 'large'
        },
        {
            header: 'Quantity',
            field: 'Quantity',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum'
        },
        {
            header: 'Inventario',
            field: 'Inventario',
            className: 'small',
            Format: 'Decimal',
        },

        {
            header: 'Área',
            field: 'Area',
        },
        {
            header: 'Unidad',
            field: 'UnitName',
            className: 'small',
        },
        {
            header: 'Comentario',
            field: 'Comment',
            className: 'large',
        },
        {
            header: 'Permiso bodega',
            field: 'UsuarioPermisoBodega',
            className: 'small',
        },
        {
            header: 'Fecha permiso bodega',
            field: 'FechaPermisoBodega',
            Format: 'DateTime',
        },
        
        
        {
            header: 'Autorizado',
            field: 'PermisoBodega',
            frozen: 'true',
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            onChange: (e, { data, value }) => {
                if (selected.length === 0) {
                    setSelected([data]);
                }
                setShowDialogPassword(true);
            },
        },

    ];

    const table = {
        Data: data,
        Columns: colums,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
        showModal: purchaseRequest => {
            setRequisaEdit(purchaseRequest);
            setModal(true);
        },
    }

    const changeDetalle = (detalle) => {
        let l = data;
        const i = l.findIndex(e => e.IdPurcharesRequestDetail === detalle.IdPurcharesRequestDetail);
        if (!l[i]?.PermisoBodega) {
            l[i].IdEstado = 3326
            l[i].PermisoBodega = true
            l[i].EstadoPD = 'Solicitado'
        } else {
            l[i].IdEstado = 3600
            l[i].PermisoBodega = false
            l[i].EstadoPD = 'Revisión Bodega'
        }
    }

    const authPermiso4 = async () => {
        if (selected.length > 0) {
            selected.forEach(async (detalle) => {
                const data = {
                    IdPurchaseRequestDetail: detalle.IdPurcharesRequestDetail,
                    Usuario: userAuth.Usuario,
                    Rol: userAuth.Rol,
                    Password: password,
                    PermisoBodega: !detalle.PermisoBodega
                }
                const a = await changePermisoPurchaseRequestDetailBodega(data);
                if(a.length > 0){
                    toastShow(toast, a[0].error ? 'warn' : 'success', a[0].mssg);
                    if(a[0]?.error){
                    }else{
                        changeDetalle(detalle, 1);
                    }
                }

                // toastShow(toast, 'success', 'Permiso cambiado.');
            })

        } else {
            toastShow(toast, 'error', 'Seleccione un detalle.');
        }
        setShowDialogPassword(false);
        onHide();
        getInfo();
        setSelected([]);
    }

    const onHide = () => {
        setModal(false);
        setRequisaEdit(null);
        setPassword('');
    }

    useEffect(() => {
        setTitlePage('Liberar Bodega');
        getInfo();
    }, [])

    return (
        <div>
            <Toast ref={toast} />
            <DialogPassword
                password={password}
                setPassword={setPassword}
                display={showDialogPassword}
                onHide={() => setShowDialogPassword(false)}
                selected={selected}
                loading={loading}
                authPermiso={authPermiso4}
                showInput={true}
            />
            <Dialog visible={showModal} onHide={onHide} closeOnEscape={false} >
                <RequisaComprasModalCrud idRequisa={requisaEdit} />
            </Dialog>
            <Card
                titulo={<div className='botones'>
                    <h3>Liberar Bodega</h3>
                    <Button icon='pi pi-refresh' onClick={getInfo} />
                </div>}
                contenido={<div className='mt-4' style={{ height: '88vh' }}>
                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}

export default LiberarBodegaScreen